import React from "react";
import reportWebVitals from "../reportWebVitals";
import { Box, CircularProgress, Stack } from "@mui/material";

export default function LoadingPage() {
  return (
      <Box sx={{ display:"flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
          <Stack alignItems="center" justifyContent="center">
              <CircularProgress size={100} thickness={4}/>
          </Stack>
      </Box>
  );
}

reportWebVitals();
